<template>
  <div class="app-container">
    <el-col :span="12" :xs="24" class="padding-right-30">
      <!-- <el-form v-model="queryForm" :inline="true" class="query-form">
        <el-form-item>
          <el-input v-model="queryForm.Name" placeholder="链接名称" @keyup.enter.native="onSearch" />
        </el-form-item>
      </el-form>
      <el-divider class="query-form-divider" /> -->
      <div class="query-button-wrap margin-bottom-20">
        <!-- <el-button type="primary" @click="onSearch"><i class="el-icon-search" />查询</el-button> -->
        <el-button type="success" @click="handleCreateNewKey"><i class="el-icon-plus" />添加字典项</el-button>
      </div>

      <el-table v-loading="listLoading" :data="keyList" element-loading-text="Loading" border stripe fit highlight-current-row @sort-change="sort" @row-click="showRow">
        <el-table-column type="index" width="50" />
        <!-- <el-table-column :prop="" /> -->
        <el-table-column label="键" prop="key" sortable />
        <el-table-column label="字典名称" prop="displayName" />
        <el-table-column label="操作" width="228">
          <template slot-scope="scope">
            <el-button size="mini" @click="handleKeyEdit(scope.$index, scope.row)">编辑</el-button>
            <el-button size="mini" type="danger" @click="handleKeyDelete(scope.$index, scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-col>
    <el-col :span="12" :xs="24">
      <div class="query-button-wrap margin-bottom-20">
        <el-button :disabled="currentKey==0?true:false" type="success" @click="handleCreateNewValue"><i class="el-icon-plus" />添加字典值</el-button>
      </div>

      <el-table :data="valueList" element-loading-text="Loading" border stripe fit highlight-current-row @sort-change="sort">
        <el-table-column type="index" width="50" />
        <!-- <el-table-column :prop="" /> -->
        <el-table-column label="名称" prop="displayName" sortable />
        <el-table-column label="值" prop="key" />
        <el-table-column label="备注" prop="remark" />
        <el-table-column label="操作" width="228">
          <template slot-scope="scope">
            <el-button size="mini" @click="handleValueEdit(scope.$index, scope.row)">编辑</el-button>
            <el-button size="mini" type="danger" @click="handleValueDelete(scope.$index, scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-col>
    <el-dialog :title="form.data.id>0?'编辑':'创建'" :visible.sync="form.visible" width="500px">
      <el-form v-if="form.visible" ref="roleForm" :model="form.data" label-position="top" label-width="80px" :rules="form.rules">

        <el-form-item label="字典的键名称" prop="key">
          <el-input v-model="form.data.key" autocomplete="off" />
        </el-form-item>

        <el-form-item label="字典名称" prop="displayName">
          <el-input v-model="form.data.displayName" autocomplete="false" />
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-divider />
        <el-button type="default" @click="form.visible=false">取消</el-button>
        <el-button type="primary" @click="handleKeySave">保存</el-button>
      </div>
    </el-dialog>

    <!--value form-->
    <el-dialog :title="valueForm.data.id>0?'编辑':'创建'" :visible.sync="valueForm.visible" width="500px">
      <el-form v-if="valueForm.visible" ref="valueForm" :model="valueForm.data" label-position="top" label-width="80px" :rules="valueForm.rules">

        <el-form-item label="显示的名称" prop="displayName">
          <el-input v-model="valueForm.data.displayName" autocomplete="off" />
        </el-form-item>

        <el-form-item label="数据值" prop="key">
          <el-input v-model="valueForm.data.key" autocomplete="off" />
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input v-model="valueForm.data.remark" autocomplete="off" />
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-divider />
        <el-button type="default" @click="valueForm.visible=false">取消</el-button>
        <el-button type="primary" @click="handleValueSave">保存</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
export default {
  filters: {
    statusFilter(status) {
      const statusMap = {
        published: "success",
        draft: "gray",
        deleted: "danger"
      };
      return statusMap[status];
    }
  },
  data() {
    return {
      multipleSelection: [],
      radio: "",
      selected: {},

      currentKey: 0,
      keyList: null,
      valueList: null,
      friendLinkType: null,
      listLoading: true,
      pagesize: 20,
      page: 1,
      totalCount: 0,
      queryForm: {
        Name: "",
        SkipCount: 0,
        Sorting: "id descending",
        MaxResultCount: 20
      },
      form: {
        visible: false,
        submitting: false,
        data: {
          key: "",
          sequence: 0,
          displayName: "",
          id: 0,

          tenantId: this.$store.getters['app/tenantId']
          //parentId: 0,
        },
        rules: {
          key: [
            {
              required: true,
              message: "请输入字典的键名称",
              trigger: "change"
            },
            {
              max: 100,
              message: "最多100个字符",
              trigger: "blur"
            }
          ],
          sequence: [
            {
              required: true,
              message: "请输入显示顺序",
              trigger: "change"
            }
          ],
          displayName: [
            {
              required: true,
              message: "请输入字典名称",
              trigger: "change"
            },
            {
              max: 100,
              message: "最多100个字符",
              trigger: "blur"
            }
          ]
        }
      },
      valueForm: {
        visible: false,
        submitting: false,
        data: {
          id: 0,
          parentId: 0,
          sequence: 0,
          displayName: "",
          key: "",
          remark: "",
          tenantId: this.$store.getters['app/tenantId']
        },
        rules: {
          key: [
            {
              required: true,
              message: "请输入字典值",
              trigger: "change"
            },
            {
              max: 100,
              message: "最多100个字符",
              trigger: "blur"
            }
          ],
          sequence: [
            {
              required: true,
              message: "请输入显示顺序",
              trigger: "change"
            }
          ],
          displayName: [
            {
              required: true,
              message: "请输入字典值名称",
              trigger: "change"
            },
            {
              max: 100,
              message: "最多100个字符",
              trigger: "blur"
            }
          ]
        }
      }
    };
  },
  computed: {
    formTitle() {
      return this.form.id ? "编辑" : "创建";
    }
  },
  watch: {
    page: function(val, oldVal) {
      this.fetchData(val);
    }
  },
  created() {
    this.fetchData(); // 如果开启了默认排序,不需要这一行
  },
  methods: {
    fetchData() {
      const that = this;
      that.listLoading = true;
      that.$abpApi.dataDictionaries
        .getAll({
          isParent: true
        })
        .then(response => {
          that.keyList = response.data.items;
          that.listLoading = false;
        });
    },
    // 查询
    onSearch() {
      this.fetchData(1);
    },
    // 切换切面,在watch中监听 page
    current_change(e) {
      this.page = e;
    },
    // 排序
    sort(e) {
      if (e.prop && e.order) {
        this.queryForm.Sorting = `${e.prop} ${e.order}`;
      } else {
        this.queryForm.Sorting = "id descending";
      }
      this.fetchData(1);
    },
    handleSizeChange(e) {
      this.pagesize = e;
      this.fetchData(1);
    },
    handleCreateNewKey() {
      //this.clearValidate("roleForm");
      //this.clearValidate("roleForm");
      this.form.data.id = 0;
      this.form.data.key = "";
      this.form.data.parentId = 0;
      this.form.data.displayName = "";
      this.form.data.tenantId = this.$store.getters['app/tenantId'];
      //this.form.data.parentId = 0
      //this.$refs.roleForm.resetFields();
      this.form.visible = true;
    },
    handleCreateNewValue() {
      //this.clearValidate("valueForm");
      if (this.currentKey > 0) {
        this.valueForm.data.id = 0;
        this.valueForm.data.parentId = this.currentKey;

        this.valueForm.data.displayName = "";
        this.valueForm.data.key = "";
        this.valueForm.data.remark = "";
        this.valueForm.visible = true;
        this.valueForm.tenantId = this.$store.getters['app/tenantId'];
      }
    },
    handleKeyEdit($index, $row) {
      // this.$refs.roleForm.resetFields()
      const id = $row.id;
      this.$abpApi.dataDictionaries
        .get({
          id: id
        })
        .then(res => {
          this.form.data = res.data;
          this.form.visible = true;
        });
    },
    handleValueEdit($index, $row) {
      // this.$refs.roleForm.resetFields()sdf
      const id = $row.id;
      this.$abpApi.dataDictionaries
        .get({
          id: id
        })
        .then(res => {
          this.valueForm.data = res.data;
          this.valueForm.visible = true;
        });
    },
    handleKeyDelete($index, $row) {
      const id = $row.id;
      this.$confirm("您确认要删除此字典项吗", "删除提示").then(() => {
        this.$abpApi.dataDictionaries
          .delete({
            id: id
          })
          .then(res => {
            console.log("delete then");
            this.$message({
              type: "success",
              message: "删除成功"
            });
            this.fetchData();
          })
          .catch(error => {
            console.log("delete catch");
            // this.$message({
            //   type: 'error',
            //   message: '删除失败了!'+error.message
            // })
          });
      });
    },
    handleValueDelete($index, $row) {
      const id = $row.id;
      this.$confirm("您确认要删除此字典值吗", "删除提示").then(() => {
        this.$abpApi.dataDictionaries
          .delete({
            id: id
          })
          .then(res => {
            console.log("delete then");
            this.$message({
              type: "success",
              message: "删除成功"
            });
            //this.fetchData();
            this.showRow($row);
          })
          .catch(error => {
            console.log("delete catch");
            // this.$message({
            //   type: 'error',
            //   message: '删除失败了!'+error.message
            // })
          });
      });
    },
    handleKeySave() {
      this.$refs.roleForm.validate(valid => {
        if (valid) {
          this.form.submitting = true;
          this.form.data.tenantId = this.$store.getters['app/tenantId'];
          let fn;
          if (this.form.data.id) {
            fn = this.$abpApi.dataDictionaries.update;
          } else {
            fn = this.$abpApi.dataDictionaries.create;
          }
          fn(this.form.data).then(res => {
            this.form.submitting = false;
            this.form.visible = false;

            this.fetchData();
          });
          //  .fail(res => {
          //    this.form.submitting = false
          //    this.form.visible = false
          //  })
        }
      });
    },
    handleValueSave() {
      this.$refs.valueForm.validate(valid => {
        if (valid) {
          this.valueForm.submitting = true;
          this.valueForm.data.tenantId = this.$store.getters['app/tenantId'];
          let fn;
          if (this.valueForm.data.id) {
            fn = this.$abpApi.dataDictionaries.update;
          } else {
            fn = this.$abpApi.dataDictionaries.create;
          }
          fn(this.valueForm.data).then(res => {
            this.valueForm.submitting = false;
            this.valueForm.visible = false;

            this.$abpApi.dataDictionaries
              .getListByParentId({
                parentId: this.currentKey
              })
              .then(res => {
                this.valueList = res.data.items;
              });
          });
          //  .fail(res => {
          //    this.form.submitting = false
          //    this.form.visible = false
          //  })
        }
      });
    },
    jumpDetail($row) {
      this.$router.push({
        name: "cmsFriendLinkDetail",
        params: {
          id: $row.id
        }
      });
    },
    showRow(row) {
      this.currentKey = row.id;
      this.$abpApi.dataDictionaries
        .getListByParentId({
          parentId: row.id
        })
        .then(res => {
          this.valueList = res.data.items;
        });
    },
    clearValidate(formName) {
      this.$refs[formName].clearValidate();
    }
  }
};
</script>
